export default "__VITE_ASSET__W4WRHMuwpgCApg36H4xvRg__"